/*
 * Copyright (c) 2022. Haodong JU
 */

import Vue from 'vue'
import Router from 'vue-router'
import DishesDetail from '@/views/AadenPages/dishes/dish/detail/DishesDetailPage'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    component: () => import('@/views/dashboard/Index'),
    children: [// Dashboard
      {
        name: '控制面板', path: '', component: () => import('@/views/dashboard/Dashboard'), // component: () => import('@/views/dashboard/DashboardNew'),
      }, {
        name: 'dishDetail', path: 'dish/detail/:id', props: true, component: DishesDetail,
      }, {
        name: 'export', path: 'bills/export', component: () => import('@/views/AadenPages/export/ExportPage'),
      }, {
        name: 'Zbon_list', // Zbon列表
        path: 'bills/zbonlist',
        component: () => import('@/views/AadenPages/bills/ZbonList'),
      }, {
        name: 'Zbon_calendar', // Zbon日历
        path: 'bills/daily-zbon',
        component: () => import('@/views/AadenPages/bills/DailyZbon'),
      }, {
        name: 'category', // 分类
        path: 'dishes/labels-manage',
        component: () => import('@/views/AadenPages/dishes/dish/category/CategoryPage'),
      }, {
        name: 'repertory', // 库存
        path: 'dishes/cache-table',
        component: () => import('@/views/AadenPages/dishes/DCacheTable'),
      }, {
        name: 'product', // 商品
        path: 'dishes/dishes-manage',
        component: () => import('@/views/AadenPages/dishes/dish/DishesManagePage'),

      }, {
        name: 'dish_statistics', // 商品统计
        path: 'Sales/dish-statistics',
        component: () => import('@/views/AadenPages/statistic/DishStatistics'),
      }, {
        name: 'product_out_statistics', // 商品出库统计
        path: 'Sales/dish-delivery-statistics',
        component: () => import('@/views/AadenPages/dishes/DishDeliveryStatistics'),
      }, {
        name: 'attribute_group', // 属性组
        path: 'dishes/attribute-group',
        component: () => import('@/views/AadenPages/dishes/dish/attribute/AttributeGroupPage'),

      }, {
        name: '属性',
        path: 'dishes/attributeByGroup/:groupId',
        props: true,
        component: () => import('@/views/AadenPages/dishes/dish/attribute/AttributePage'),

      },

      {
        name: 'BuffetChildSetting',
        path: 'dishes/buffet-child-setting',
        component: () => import('@/views/AadenPages/dishes/dish-display/ConsumeTypePage'),

      }, {
        name: 'Pfand', path: 'dishes/pfand', component: () => import('@/views/AadenPages/dishes/Pfand'),
      }, {
        name: 'discount_rule', // 折扣规则
        path: 'dishes/discount-rules-setting',
        component: () => import('@/views/AadenPages/dishes/DiscountRulesSetting'),
      }, {
        name: 'discount_rule_new', // 折扣规则(新)
        path: 'Sales/discount-rules-newsetting',
        component: () => import('@/views/AadenPages/dishes/DiscountRulesSettingNew'),
      }, {
        name: 'threshold_color', // 阈值颜色
        path: 'dishes/threshold-color-setting',
        component: () => import('@/views/AadenPages/dishes/DThresholdColorSetting'),
      }, {
        name: 'DishDiscountSetting',
        path: 'dishes/discount-discount-setting',
        component: () => import('@/views/AadenPages/dishes/DishDiscountSetting'),
      }, {
        name: 'section', // 分区
        path: 'Tables/section-manage',
        component: () => import('@/views/AadenPages/personAndTable/SectionManage'),
      }, {
        name: 'table', // 桌子
        path: 'Tables/tables-manage',
        component: () => import('@/views/AadenPages/personAndTable/TablesManage'),
      }, {
        name: 'person', // 人员
        path: 'Tables/person-manage',
        component: () => import('@/views/AadenPages/personAndTable/PersonManage'),
      }, {
        name: 'allBills', // 全部账单
        path: 'bills/history-bills',
        component: () => import('@/views/AadenPages/bills/historyBills/HistoryBills'),
      }, {
        name: 'my_cash_book', // 我的记账本
        path: 'bills/cashbook',
        component: () => import('@/views/AadenPages/bills/cashbook/CashBook'),
      }, {
        name: 'Datev',
        path: 'bills/datev',
        component: () => import('@/views/AadenPages/export/childPage/DatevSettingFragment'),
      }, {
        name: 'operationRecords', // 操作记录
        path: 'settings/operationlist',
        component: () => import('@/views/AadenPages/settings/OperationList'),
      }, {
        name: 'device_list', // 设备列表
        path: 'print/devicelist',
        component: () => import('@/views/AadenPages/print/DeviceList'),
      }, {
        name: 'print_bill_list', // 打印单列表
        path: 'print/printerlist',
        component: () => import('@/views/AadenPages/print/PrintRecordList'),
      }, {
        name: 'print_section', // 打印分区
        path: 'print/section-printer-setting',
        component: () => import('@/views/AadenPages/print/SectionPrinterSetting'),
      }, {
        name: '用餐轮数名称列表',
        path: 'print/named-table-round-list',
        component: () => import('@/views/AadenPages/print/NamedTableRoundList'),
      }, {
        name: 'delivery_rang_setting_old', // 配送距离Old
        path: 'Sales/delivery-range-setting',
        component: () => import('@/views/AadenPages/settings/TakeawaySetting/DeliveryRangeSetting'),
      }, {
        name: 'distributionDistance', // 配送距离
        path: 'TakeawaySetting/delivery-range-setting',
        component: () => import('@/views/AadenPages/settings/TakeawaySetting/DeliveryRangeSetting'),
      }, {
        name: '营业时间Old', // old
        path: 'Sales/open-time-setting',
        component: () => import('@/views/AadenPages/settings/TakeawaySetting/OpenTimeSetting'),
      }, {
        name: 'opening_hours', // 营业时间
        path: 'TakeawaySetting/open-time-setting',
        component: () => import('@/views/AadenPages/settings/TakeawaySetting/OpenTimeSetting'),
      }, {
        name: 'free_info_bon_old', // 自由信息单old
        path: 'settings/freeInfoSheet',
        component: () => import('@/views/AadenPages/settings/FreeInfoSheet'),
      }, {
        name: 'free_info_bon', // 自由信息单
        path: 'print/freeInfoSheet',
        component: () => import('@/views/AadenPages/settings/FreeInfoSheet'),
      }, {
        name: 'pay', // 支付
        path: 'settings/paymentpage',
        component: () => import('@/views/AadenPages/settings/PaymentPage'),
      }, {
        name: 'allergName', // 过敏源
        path: 'dishes/allergen-setting',
        component: () => import('@/views/AadenPages/dishes/dish/AllergenSettingPage'),
      }, {
        name: 'Q&A', path: 'settings/q-and-a', component: () => import('@/views/AadenPages/settings/QandA'),
      }, {
        name: 'restaurantInfo', // 餐馆信息
        path: 'settings/restaurant-info',
        component: () => import('@/views/AadenPages/settings/RestaurantInfo'),
      }, {
        name: 'system', // 系统
        path: 'settings/aaden-system-setting',
        component: () => import('@/views/AadenPages/settings/AadenSystemSetting'),
      }, {
        name: 'image', // 图片
        path: 'settings/restaurant-image',
        component: () => import('@/views/AadenPages/settings/image/RestaurantImage'),
      }, {
        name: 'bannerImg', // 轮播图
        path: 'settings/banner-image',
        component: () => import('@/views/AadenPages/settings/image/BannerImage'),
      }, {
        name: 'TaxSetting',
        path: 'settings/tax-setting',
        component: () => import('@/views/AadenPages/settings/TaxSetting'),
      }, {
        name: 'Seite mit den Rechnungsdetails',
        path: 'Details/BillDetail/:id',
        props: true,
        component: () => import('@/views/AadenPages/bills/historyBills/BillDetailPage'),
      }, {
        name: 'user_info', // 用户信息
        path: 'Sales/user-management',
        props: true,
        component: () => import('@/views/AadenPages/customer/UserManagement'),
      }, {
        name: 'memberCard_sales_records', // 会员卡销售记录
        path: 'bills/member-card-sale-record',
        props: true,
        component: () => import('@/views/AadenPages/customer/SaledCouponList'),
      }, {
        name: 'consumption_log', // 消费记录
        path: 'Details/PaymentLog/:id',
        props: true,
        component: () => import('@/views/AadenPages/bills/PaymentLog'),
      }, {
        name: 'BonTemplate',
        path: 'print/bon-template',
        props: true,
        component: () => import('@/views/AadenPages/print/BonTemplate'),
      }, // Pages

      {
        name: 'ResourcePage',
        path: 'storage/resource',
        props: true,
        component: () => import('@/views/AadenPages/storage/ResourceListPage'),
      },

      {
        name: 'DishRelation',
        path: 'storage/connection',
        props: true,
        component: () => import('@/views/AadenPages/storage/DishRelationPage'),
      },

      {
        name: 'Unit',
        path: 'storage/unit',
        props: true,
        component: () => import('@/views/AadenPages/storage/UnitPage'),
      },

      {
        name: 'UnitSet',
        path: 'storage/unitSet',
        props: true,
        component: () => import('@/views/AadenPages/storage/UnitSetPage'),
      },
      {
        name: 'ChangeRecord',
        path: 'storage/changeRecord',
        props: true,
        component: () => import('@/views/AadenPages/storage/StorageRecords.vue'),
      },
      {
        name: 'Inventory',
        path: 'storage/inventory',
        props: true,
        component: () => import('@/views/AadenPages/storage/InventoryPage.vue'),
      },

    ],
  }],
})

